import React, { useEffect } from 'react'
import './index.scss'
import Header from '@shared/Header'
import Footer from '@shared/Footer'
import { Container } from 'react-bootstrap'
import ServicesOne from '@assets/images/services-one.jpg'
import ServiceArrowLeft from '@assets/images/left-down-arrow.png'
import ServiceArrowRight from '@assets/images/right-top.png'
import ServicesBgArrow from '@assets/images/services-bg-arrow.png'
import AccordionOne from '@assets/images/accordion-1.jpg'

const FAQEXpertPage = () => {
  const [activeAccordion, setActiveAccordion] = React.useState('1')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Header />
      <div className='faq'>
        <Container>
          <div className='pt-5'>
            <h1 className='services-title'>
              Empowering Experts, Expanding Opportunities
            </h1>
          </div>
          <div className='services-content'>

            <div className='services-content-item'>
              <div className='services-content-item__two'>

                <div
                  className='services-content-item__two-content three'
                  style={{ backgroundImage: `url(${ServiceArrowRight})` }}
                >
                  <h5>Grow Your Expertise</h5>
                  <p>
                    Join a global platform that values
                    your skills and connects you with
                    a network of clients seeking
                    expert solutions.
                  </p>
                </div>
                <div className='services-content-item__two-content four top_pt'>
                  <h5>Flexible Work and Earnings</h5>
                  <p>
                    Set your rates, choose projects that
                    match your expertise, and work on
                    your own terms.
                  </p>
                </div>
              </div>
            </div>

            <div className='services-content-item'>
              <div className='services-content-item__four'>
                {/* Accordion 1 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('1')}
                  >
                    <p>
                      <span>01</span> How does ExpertBunch support expert growth?
                    </p>
                    <span>{activeAccordion === '1' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '1' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> - ExpertBunch connects freelancers with clients across diverse industries, enabling them to build a robust portfolio, gain valuable experience in emerging fields, and expand their professional network for continuous career growth.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 2 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('2')}
                  >
                    <p>
                      <span>02</span> How do experts set their rates on ExpertBunch?
                    </p>
                    <span>{activeAccordion === '2' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '2' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> -  Experts have full control over their pricing, allowing them to set competitive rates and negotiate terms directly with clients to ensure fair compensation aligned with their skills and project complexity.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 3 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('3')}
                  >
                    <p>
                      <span>03</span> What type of projects can experts find on ExpertBunch?
                    </p>
                    <span>{activeAccordion === '3' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '3' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> -  ExpertBunch offers a wide range of projects, from one-time consultations to long-term engagements, spanning categories such as software development, AI & machine learning, finance, marketing, design, and consulting.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 4 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('4')}
                  >
                    <p>
                      <span>04</span> How does the bidding process work for experts?
                    </p>
                    <span>{activeAccordion === '4' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '4' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> -  Freelancers can submit competitive proposals through a transparent bidding system, giving clients the ability to review and select the best fit based on expertise, budget, and project requirements.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 5 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('4')}
                  >
                    <p>
                      <span>05</span> Is there a rating or review system on ExpertBunch?
                    </p>
                    <span>{activeAccordion === '4' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '4' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> -  Yes, clients can rate and provide feedback on freelancer performance, helping build credibility and trust within the platform.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default FAQEXpertPage
